"use client";

import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

import { Color, Product, Size } from "../../../payload/payload-types";
import { useCart } from "../../_providers/Cart";
import { Button, Props } from "../Button";

import classes from "./index.module.scss";

import {
  MdOutlineAddShoppingCart,
  MdShoppingCartCheckout,
} from "react-icons/md";
import { useQuickAdd } from "../../_providers/QuickCart";
import {languages} from "monaco-editor";


export const AddToCartButton: React.FC<{
  product: Product;
  quantity?: number;
  color?: Color;
  size?: Size;
  variation?: {};
  className?: string;
  appearance?: Props["appearance"];
}> = (props) => {
  const {
    product,
    quantity = 1,
    color,
    size,
    variation,
    className,
    appearance = "primary",
  } = props;

  const { cart, addItemToCart, isProductInCart, hasInitializedCart } =
    useCart();

  const { quickAdd, setQuickAdd } = useQuickAdd();

  const [isInCart, setIsInCart] = useState<boolean>();
  const router = useRouter();

  useEffect(() => {
    setIsInCart(isProductInCart(product));
  }, [isProductInCart, product, cart]);
  //label={isInCart ? `✓ View in cart` : `Add to cart`}

  const setAdd = (value: boolean) => {
    setQuickAdd(value);
  };

  return (
    <Button
      href={isInCart ? "/cart" : undefined}
      type={!isInCart ? "button" : undefined}
      label={
        isInCart ? (
          <>
            {" "}
            ✓ View in cart &nbsp; &nbsp; <MdShoppingCartCheckout
              size={7}
            />{" "}
          </>
        ) : (
          <>
            Add to cart &nbsp; &nbsp; <MdOutlineAddShoppingCart />
          </>
        )
      }
      el={isInCart ? "link" : undefined}
      appearance={appearance}
      className={[
        className,
        classes.addToCartButton,
        appearance === "default" && isInCart && classes.green,
        !hasInitializedCart && classes.hidden,
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={
        !isInCart
          ? () => {
              addItemToCart({
                product,
                quantity,
                color,
                size,
                variation,
              });
              setAdd(true);
              //router.push("/cart");
            }
          : undefined
      }
    />
  );
};
